import { Box, styled } from '@mui/material';
import { Handle, type Node, type NodeProps, Position } from '@xyflow/react';
import { ActionNodeContent } from './action-node-content';
import { NodeHeader } from '../node-header';
import type { ActionNodeData } from '../../../../components/workflow-editor/mappers/map-canvas-content.types';

export const ActionNode = ({ data }: NodeProps<Node<ActionNodeData, 'action'>>) => {
  return (
    <NodeWrapper className="nopan">
      <NodeHeader nodeTitle="Action" />
      <ActionNodeContent data={data} />
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
    </NodeWrapper>
  );
};

const NodeWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.lwWhite[100],
  border: `1px solid ${theme.palette.lwSecondaryAccentLight[20]}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(2),
  maxWidth: 320,
  maxHeight: 250,
}));
